module.exports = __webpack_public_path__ + "img/t1-home-headshot.d1c62ab0.png";